import React from 'react'
import PropTypes from 'prop-types'
import { Pagination } from 'antd'
import { Table } from 'components/patterns'
import 'styles/PagedTable.css'
import strings from 'utils/strings.js'
import { SEARCH_PAGE_SIZE } from 'utils/constants'
import { classNames } from 'utils/utils'
import { createFeatureRowKey } from 'utils/uriHelpers'

export default class PagedTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: '',
      resource: this.props.resource,
      page: this.props.startIndex
        ? Math.ceil(this.props.startIndex / SEARCH_PAGE_SIZE)
        : 1,
      maintainSelectedPage: false,
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!props.isSearching && this.props.isSearching) {
      if (this.state.maintainSelectedPage) {
        this.setState({
          maintainSelectedPage: false,
        })
      } else {
        this.setState({
          page: 1,
        })
      }
    }

    if (props.startIndex !== this.props.startIndex) {
      this.setState({
        page: Math.ceil(props.startIndex / SEARCH_PAGE_SIZE),
      })
    }
  }

  onPageChange = (page) => {
    const { onPageChange } = this.props
    onPageChange(page)
    // Only maintain pagination page if a page tab was clicked
    this.setState({
      page,
      maintainSelectedPage: true,
    })
  }

  render() {
    const {
      greyRows,
      defaultTopMargin,
      onRowClick,
      className,
      columns,
      dataSource,
      totalResults,
      isSearching,
      hidePagination,
      noResultText,
    } = this.props

    const noDataText = noResultText || strings.no_results_returned

    return (
      <div
        style={{ marginTop: defaultTopMargin || 10 }}
        className={classNames('paged-table', {
          'hide-pagination': hidePagination,
        })}
      >
        {!isSearching && (
          <>
            <Table
              className={className || ''}
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              onRow={(record) => ({
                onClick: () => (onRowClick ? onRowClick(record) : () => {}),
              })}
              rowClassName={(record, index) =>
                `${record.selected ? 'selected ' : ''}${
                  greyRows && index % 2 !== 0 ? 'grey-row' : ''
                }`
              }
              rowKey={(record) => createFeatureRowKey(record)}
              showEmptyText={true}
              noResultText={{ emptyText: noDataText }}
            />
            {!hidePagination && (
              <>
                {totalResults > SEARCH_PAGE_SIZE && (
                  <Pagination
                    current={this.state.page}
                    defaultCurrent={1}
                    total={totalResults}
                    onChange={this.onPageChange}
                    showTotal={(total, range) => (
                      <div>
                        {`${range[0]}-${range[1]} ${strings.of} `}
                        <strong>{`${total} ${strings.results}`}</strong>
                      </div>
                    )}
                  />
                )}
                {totalResults <= SEARCH_PAGE_SIZE && (
                  <div style={{ margin: 10 }}>
                    {`${totalResults === 0 ? '0' : '1'}-${totalResults} ${
                      strings.of
                    } `}
                    <strong>{`${totalResults} ${strings.results}`}</strong>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    )
  }
}

PagedTable.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  hideFilter: PropTypes.bool,
  greyRows: PropTypes.bool,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowClick: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.object),
  noSubmitOnEnter: PropTypes.bool,
  tableSize: PropTypes.number,
  startIndex: PropTypes.number,
  totalPages: PropTypes.number,
  resource: PropTypes.string,
  searchString: PropTypes.string,
  onPageChange: PropTypes.func,
  totalResults: PropTypes.number,
  hidePagination: PropTypes.bool,
  defaultTopMargin: PropTypes.number,
  isSearching: PropTypes.bool,
  noResultText: PropTypes.string,
  rowClassName: PropTypes.oneOf([PropTypes.string, PropTypes.func]),
}
